






















































































































import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import AuthorityService from '@/domain/security/authority.service';
import UserProfile from '@/domain/access/domain/profile.enum';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ColumnModal from './billing-column-modal.component.vue';

@Component({ components: { MainButton, VbTooltipSlot, ColumnModal } })
export default class FilterTitleComponent extends Vue {
  @Prop({
    required: false,
    default: false,
  })
  private filter!: boolean;

  private hasAdministratorAuthority: boolean = false;

  profile: UserProfile = UserProfile.USER;

  businessUnitId: string = '';

  private showColumnModal: boolean = false;

  private columnModalKey: number = 0;

  // TODO: travando a API do billing, desabilitar temporariamente
  private disabledTemporarily: boolean = true;

  @Watch('showColumnModal')
  private updateColumnModalState(value: boolean) {
    this.showColumnModal = value;
    this.columnModalKey += 1;
  }

  private executeBilling(): void {
    this.$emit('executeBilling');
  }

  showErrorHistory(): void {
    this.$emit('showErrorHistory');
  }

  showContractNotBilled(): void {
    this.$emit('showContractNotBilled');
  }

  showBillableItems(): void {
    this.$emit('showBillableItems');
  }

  showCustomerAudit(): void {
    this.$emit('showCustomerAudit');
  }

  showReportInvoiceModal(): void {
    this.$emit('showReportInvoiceModal');
  }

  private get showFilter() {
    return this.filter;
  }

  private set showFilter(value: boolean) {
    this.$emit('updateFilterValue', value);
  }

  private get menuIcon(): string {
    return this.filter ? 'mdi-filter' : 'mdi-filter-outline'
  }

  private validateAuthority(): void {
    AuthorityService.authorities().then((response) => {
      if (response.includes('ADMINISTRATOR')) {
        this.hasAdministratorAuthority = true;
      }
    });
  }

  get isAdminOrSupervisor(): boolean {
    return this.hasAdministratorAuthority || this.isSupervisor;
  }

  get isSupervisor(): boolean {
    return this.profile === UserProfile.SUPERVISOR;
  }

  created() {
    this.profile = UserBusinessUnitService.currentBusinessUnit.profile;
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    this.validateAuthority();

    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }

    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      this.businessUnitId = businessUnit.id;
      this.profile = businessUnit.profile;
    })
  }

  updateColumnState($event) {
    this.$emit('updateColumn', $event)
  }
}
